export { QRViewPageTemplate } from "./QRViewPageTemplate";
